export const VGN_TOAST_MESSAGES = {
    VGN_FETCH_FAILED: "Failed to fetch Vendor's Goods Note.",
    VGN_CREATE_SUCCESS: "Vendor's Goods Note created successfully.",
    VGN_CREATE_FAILED: "Failed to create Vendor's Goods Note.",
    VGN_UPDATE_SUCCESS: "Vendor's Goods Note updated successfully.",
    VGN_UPDATE_FAILED: "Failed to update Vendor's Goods Note.",
    VGN_DELETE_SUCCESS: "Vendor's Goods Note deleted successfully.",
    VGN_DELETE_FAILED: "Failed to delete Vendor's Goods Note.",
    VGN_MATERIAL_ADD_SUCCESS: "Materials added to Vendor's Goods Note successfully.",
    VGN_MATERIAL_ADD_FAILED: "Failed to add materials to Vendor's Goods Note.",
    VGN_FETCH_MATERIALS_FAILED: "Failed to fetch materials for Vendor's Goods Note.",
    FILE_UPLOAD_FAILED: "File upload failed.",
    FILE_UPLOAD_SUCCESS: "File uploaded successfully.",
    FILE_DOWNLOAD_FAILED: "File download failed.",
    FILE_DELETE_FAILED: "File deletion failed.",
    FILE_DELETE_SUCCESS: "File deleted successfully.",
    FILE_DOWNLOAD_SUCCESS: "File downloaded successfully.",
}; 

export const VGN_MATERIAL_COLUMNS = [
  "warehouse_name",
  "vendor_name",
  "vendor_mobile_no",
  "status",
  "created",
  "created_by",
  "actions",
];

export const VGN_MATERIAL_LABELS = {
  warehouse_name: "Requested By (Warehouse)",
  vendor_name: "Vendor Name",
  vendor_mobile_no: "Vendor Contact",
  status: "Status",
  created: "Raised On",
  created_by: "Requested By",
  actions: "Actions",
};

export const VGN_STATUS_VALUE_LABELS = [
  { value: "", label: "All" },
  { value: "DRAFT", label: "Draft" },
  { value: "PENDING_FOR_APPROVAL", label: "Pending for Approval" },
  { value: "APPROVED", label: "Approved" },
  { value: "COMPLETED", label: "Completed" },
  { value: "REJECTED", label: "Rejected" },
];

export const VGN_STATUS = {
  DRAFT: "DRAFT",
  PENDING_FOR_APPROVAL: "PENDING_FOR_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  COMPLETED: "COMPLETED",
};

export const getVGNStatusColor = (status) => {
  switch (status) {
    case "DRAFT":
      return "bg-gray-100 hover:bg-gray-150 transition-colors text-gray-700";
    case "PENDING_FOR_APPROVAL":
      return "bg-blue-50 text-blue-500 transition-colors";
    case "APPROVED":
      return "bg-green-50 text-green-500 transition-colors";
    case "REJECTED":
      return "bg-red-50 text-red-500";
    case "COMPLETED":
      return "bg-teal-50 text-teal-500";
    default:
      return "bg-blue-50 hover:bg-blue-100 transition-colors text-black"; // fallback for unknown status
  }
};

export const MATERIAL_COLUMNS_VGN = [
  "product_name",
  "quantity",
  "note",
  "actions",
];

export const MATERIAL_LABELS_VGN = {
  product_name: "Material",
  note: "Note",
  quantity: "Quantity",
  actions: "Action",
};

export const materialColumns_VGN = ["product_name", "quantity", "note"];

export const materialLabels_VGN = {
  product_name: "Material",
  quantity: "Quantity",
  note: "note",
};

export const ADMIN_APPROVAL_BUTTONS = [
  {
    label: "Mark as REJECTED",
    status: VGN_STATUS.REJECTED,
    color: "bg-red-500 hover:bg-red-700",
  },
  {
    label: "Approve",
    status: VGN_STATUS.APPROVED,
    color: "bg-primary hover:bg-blue-700",
  },
];

export const VENDOR_ACTIONS = [
  {
    label: "Mark as REJECTED",
    status: VGN_STATUS.REJECTED,
    color: "bg-red-500 hover:bg-red-700",
  },
  {
    label: "Mark as Completed",
    status: VGN_STATUS.COMPLETED,
    color: "bg-green-600 hover:bg-green-700",
  },
];

export const PE_SUBMIT_BUTTONS = [
  {
    label: "Save as Draft",
    status: VGN_STATUS.DRAFT,
    color: "bg-gray-200 hover:bg-gray-300 text-gray-800",
  },
  {
    label: "Submit for Approval",
    status: VGN_STATUS.PENDING_FOR_APPROVAL,
    color:
      "bg-primary hover:bg-primary-dark text-white",
  },
];

export const PM_SUBMIT_BUTTONS = [
  {
    label: "Reject",
    status: VGN_STATUS.REJECTED,
    color: "bg-red-500 hover:bg-red-700 text-white",
  },
  {
    label: "Approve",
    status: VGN_STATUS.APPROVED,
    color: "bg-primary hover:bg-blue-700 text-white",
  },
];
